export default "__VITE_ASSET__82eaa701__"